var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.335 15c1.479 0 2.915-.495 4.08-1.407l3.664 3.664 1.178-1.179-3.663-3.663A6.63 6.63 0 0 0 15 8.333a6.674 6.674 0 0 0-6.666-6.666 6.674 6.674 0 0 0-6.667 6.666A6.674 6.674 0 0 0 8.335 15m0-11.667c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.242-5-5 2.242-5 5-5"
  })));
};
export default SvgSearch;